import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import allReducers from '../Reducers/'

// Redux Persist configuration
const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['cbtExam'], // Only persist CBT exam data
  // Blacklist other reducers that shouldn't be persisted
  blacklist: ['courses', 'Project'],
  // Debug mode to see what's being persisted
  debug: process.env.NODE_ENV === 'development'
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, allReducers);

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create store with persisted reducer
const store = createStore(
  persistedReducer,
  composeEnhancer(
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

// Create persistor
export const persistor = persistStore(store);

export default store;

